module.exports = __webpack_public_path__ + "static/media/html.2095e6d1.svg";